import React, { Component } from 'react'
import { ACCOUNT_DASHBOARD_API, ACCOUNT_LISTING, Account_STATUS_CHANGE, LOGIN_URL, USER_LOGIN_REDIRECT } from '../../config/rest_endpoints';
import { getUser } from '../../actions/session';
import { Notifications } from '../common/notification';
import { Link, withRouter, Redirect } from 'react-router-dom'
import axios from 'axios'
import CustomLoader from '../common/loader';
import { ADDITIONAL_ACCOUNT_INFO, RC_LOAD_LOGIN, USER_URL } from '../routers/RouteConstants';
import CustomModal from '../common/modal';
import AddAccount from './addAccount';
import EditAccount from './editAccountModal';
import Switch from "react-switch";
import Pagination from "react-js-pagination";


export class AccountInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            User: getUser(),
            isGetting: false,
            accountTable: [],
            message: '',
            isAddModal: false,
            isEditModal: false,
            searchValue: '',
            editData: [],
            updateMsg: '',
            activePage: 1,
            itemsCount: 10,
            totalCount: null,
            isExpire: false,
            tableData:[],
            isLoginURL:false,
            isRedirect:false,
            loginData:{},
            isRedirectLoader:false
        }
        this.accountListing = this.accountListing.bind(this)
        this.openAddModal = this.openAddModal.bind(this)
        this.closeAddModal = this.closeAddModal.bind(this)
        this.closeEditModal = this.closeEditModal.bind(this)
        this.openEditModal = this.openEditModal.bind(this)
        this.searchSpace = this.searchSpace.bind(this)
        this.closeLogOutModal = this.closeLogOutModal.bind(this)
        this.goLoginPage = this.goLoginPage.bind(this)
        this.redirectToUserSide = this.redirectToUserSide.bind(this)
    }

    componentDidMount() {
        this.accountListing()
    }

    openLogOutModal() {
        this.setState({ isExpire: true })
    }

    closeLogOutModal() {
        this.setState({ isExpire: false })
    }

    closeAddModal() {
        this.setState({
            isAddModal: false
        })
    }

    openAddModal() {
        this.setState({
            isAddModal: true
        })
    }

    openEditModal(row) {
        console.log('row', row)
        this.setState({
            isEditModal: true,
            editData: row
        })
    }

    closeEditModal() {
        this.setState({
            isEditModal: false
        })
    }

    searchSpace(e) {
        this.setState({ searchValue: e.target.value })
    }

    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber
        }, () => {
            this.accountListing()
        });
    }

    accountListing() {
        const { User, itemsCount, activePage } = this.state
        this.setState({
            isGetting: true
        })
        var headers = { "Authorization": "Bearer " + User.token };
        axios.get(`${ACCOUNT_LISTING}/${this.props.userId}/details`, { headers }).then(res => {
            if (res) {
                var resp = res.data
                console.log('resp :>> ', resp);
                this.setState({
                    accountTable: resp.data,
                    message: resp.message,
                    isGetting: false,
                    totalCount: resp.pageinfo.totalCount
                })
            }
            else {
                this.setState({
                    isGetting: true
                })
                Notifications.notify("Fetch failed", "error", "errors");
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.setState({isLoginURL:true})
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false
            })
        })
    }

    goLoginPage() {
        this.props.history.push(RC_LOAD_LOGIN)
    }

    redirectToUserSide(data) {
        this.setState({loginData:data, isRedirect:true,isRedirectLoader:true},()=>{
           if(this.state.isRedirect) {
               this.checkToRouteUser()
           }
        })
        setTimeout(() => {
            this.setState({isRedirectLoader:false})
        },2000)
    }

    checkToRouteUser() {
        const {User} = this.state
        console.log(`isRedirect`, this.state.isRedirect)
        window.open(`${USER_URL}/user/${this.props.userId}/token/${User.token}`, '_blank', 'noopener,noreferrer')
    }

    // loginUserAccount() {
    //     const { User } = this.state
    //     const payload = {
    //         "accountID":this.props.userId
    //     }
    //     this.setState({isRedirectLoader:true})
    //     const headers = { "Authorization": "Bearer " + User.token };
    //     axios.post(USER_LOGIN_REDIRECT,payload, { headers }).then(res => {
    //         if (res) {
    //             const resp = res.data.data
    //             console.log(`resp`, resp)
    //             this.redirectToUserSide(resp)
    //             this.setState({isRedirectLoader:false})
    //         }
    //     }).catch(err => {
    //         const alert = err.response
    //         console.log(`alert.data.message`, alert.data.message)
    //         if (alert.data.message === 'invalid or expired jwt') {
    //             localStorage.removeItem('user');
    //             this.setState({isLoginURL:true,isRedirectLoader:false})
                
    //             Notifications.notify(alert.data.message, "Token Expire", "error")
    //         }
    //         Notifications.notify(alert.data.message, "Failed", "error")
    //     })
    // }

    // toggleSwitch(row) {
    //     const { User } = this.state
    //     var user = row;
    //     const data = {
    //         "status": !user.status
    //     }
    //     var headers = { "Authorization": "Bearer " + User.token };
    //     axios.put(`${Account_STATUS_CHANGE}/${user.id}/changeStatus`, data, { headers }).then(res => {
    //         this.setState({
    //             updateMsg: res.data.message
    //         })
    //         this.accountListing()
    //         Notifications.notify(this.state.updateMsg, "Success", "success");
    //     })

    // }

    onRedirecting(id,accountName,type) {
        console.log('id', type)
        this.props.history.push(`${ADDITIONAL_ACCOUNT_INFO}/${id}/${accountName}/${type}`)
    }

    __renderAccountTable() {
        const { accountTable, searchValue } = this.state
        var nullData = (
            <div className="ml-4 mt-2">
                <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
            </div>
        )
        if (accountTable == null) {
            return nullData
        }
        else {
            return accountTable.filter(table => {
                if (searchValue == null) {
                    return table
                }
                else if (table.accountName.toLowerCase().includes(searchValue.toLowerCase())) {
                    return table
                }
            }).map((row, idx) => {
                return (
                    <tr key={idx}>
                        <td style={{textAlign:'center'}}>{row.accountName}</td>
                        <td style={{textAlign:'center'}}>{row.accountEmail}</td>
                        <td style={{textAlign:'center'}}>{row.location}</td>
                        <td style={{textAlign:'center'}}>{row.createDate}</td>
                        <td style={{textAlign:'center'}}>{row.balance}</td>
                        <td style={{textAlign:'center'}}>{row.creditLimit}</td>
                        <td style={{textAlign:'center'}}>{row.sessions}</td>
                        <td style={{textAlign:'center'}}>{row.cps}</td>
                        <td style={{textAlign:'center'}}>{row.status === 'Disabled' ? <span className="badge badge-danger">Disabled</span> : row.status ==="Enabled" ? <span className="badge badge-success">Enabled</span> : <span className="badge badge-info">Credit Hold</span>}</td>
                        {/* <td><span className="size-1"><Switch height={20} width={50} onChange={this.toggleSwitch.bind(this, row)} checked={row.status} /></span></td> */}
                        <td className='edit-button'><i className="fa fa-edit mr-2" onClick={this.openEditModal.bind(this, row)}></i></td>
                    </tr>
                )
            })
        }

    }

    render() {
        const { isGetting, isAddModal, isEditModal, editData, itemsCount, totalCount, isExpire,User } = this.state
    
        let addAccountModal = {
            details: {
                info: `Login ${this.props.accountName.toUpperCase()} Account`,
                msg:''
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeAddModal },
            cancelBtn: { label: "Cancel", action: this.closeAddModal }
        }
        let editAccountModal = {
            details: {
                info: "Edit Account",
                msg: <EditAccount close={this.closeEditModal} previousData={editData} classListing={this.accountListing} />
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeEditModal },
            cancelBtn: { label: "Cancel", action: this.closeEditModal }
        }
        let logoutModal = {
            details: {
                info: "Session Expire",
                msg:
                    <div className="row">
                        <div className="col-md-12">
                            <div class="alert alert-warning alert-styled-left alert-dismissible">
                                <button type="button" class="close" data-dismiss="alert"></button>
                                <span class="font-weight-semibold">Your session!</span> has expire please <a href="#" class="alert-link">login again</a>.
							    </div>
                        </div>
                        <button type="submit" className="btn bg-danger mr-2 ml-auto" onClick={this.goLoginPage}><i class="icon-key mr-2"></i>Login </button>
                    </div>
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeLogOutModal },
            cancelBtn: { label: "Cancel", action: this.closeLogOutModal }
        }
        if(this.state.isLoginURL === true) {
            return <Redirect to={LOGIN_URL} ></Redirect>
        }

      

        return (
            <div>
                <CustomModal
                    visibility={isExpire}
                    customBodyCSS={"h20"}
                    modalType={"danger"}
                    modalHeader={"danger"}
                    details={logoutModal.details}
                    showBtns={false}
                    cancelBtn={logoutModal.cancelBtn}
                    crossBtn={logoutModal.crossBtn}
                />
                <CustomModal
                    visibility={isAddModal}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    details={addAccountModal.details}
                    modalSize={"large"}
                    showBtns={false}
                    cancelBtn={addAccountModal.cancelBtn}
                    crossBtn={addAccountModal.crossBtn}
                />
                <CustomModal
                    visibility={isEditModal}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    modalSize={"large"}
                    details={editAccountModal.details}
                    showBtns={false}
                    cancelBtn={addAccountModal.cancelBtn}
                    crossBtn={editAccountModal.crossBtn}
                />
                <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card card-body border-left-dark-alpha border-right-dark-alpha ">
                    {/* <div className="card-header header-elements-inline">
                        <div className="header-elements">
                            <button type="submit" className="btn btn-light ml-3" onClick={this.openAddModal}>Login Account <i className="fas fa-plus ml-2"></i></button>
                        </div>
                    </div> */}
                    <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer mt-2">
                        <div  className="datatable-header">
                            <div id="DataTables_Table_0_filter" className="dataTables_filter">
                                {/* <label className="fs-16"><span>Search :</span>
                                    <input type="search" className="" placeholder="Type to filter..." value={this.state.searchValue} onChange={this.searchSpace} aria-controls="DataTables_Table_0" />
                                </label> */}
                                <div class="input-group">
                                    <input type="text" class="form-control border-right-0" value={this.state.searchValue} onChange={this.searchSpace} placeholder="Filter Account" />

                                    <span class="input-group-append">
                                        <button class="btn search-button" type="button"><i class="fa fa-search"></i></button>
                                    </span>
                                </div>
                            </div>
                            <div className="header-elements">
                            <button type="submit" className="main-button btn btn-primary btn-sm ml-3 float-right" disabled={this.state.isRedirectLoader ? true : false} onClick={this.redirectToUserSide}>Login Account <i className={this.state.isRedirectLoader ? "icon-spinner4 spinner ml-1":"icon-toggle ml-1"}></i></button>
                        </div>
                        </div>
                        <div className="datatable-scroll " style={{overflowX: 'auto' }}>
                            <table  style={{border:'1px solid #ddd',borderTop:'0px solid #ddd',borderCollapse:'collapse'}} className="table table-striped no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                <thead>
                                    <tr className="stickeyHeader">
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Account Name</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Account Email</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Address</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Join Date</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Balance</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Credit Limit</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Sessions</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>CPS</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Status</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Actions</th>
                                    </tr>
                                
                                </thead>
                                <tbody>
                                    {isGetting ? <CustomLoader /> : this.__renderAccountTable()}

                                </tbody>
                            </table>
                        </div>
                        <div className="datatable-footer mt-1">
                        {totalCount >= 9 ?  
                            <div className="mt-3">
                                <Pagination
                                    activePage={this.state.activePage}
                                    itemsCountPerPage={itemsCount}
                                    totalItemsCount={totalCount}
                                    pageRangeDisplayed={5}
                                    onChange={this.handlePageChange.bind(this)}
                                />
                            </div> :''}

                            <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(AccountInformation)
